import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as PlayIcon } from "../../../../assets/Icons/play3.svg";
import { ReactComponent as Info } from "../../../../assets/Icons/info3.svg";
import { useDispatch, useSelector } from "react-redux";
import { imageUrlCheck, translateText } from "../../../../utils/utils";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";
import 'swiper/css/pagination';
import { EffectFade, Thumbs, Autoplay,Pagination } from "swiper";
import { Link } from "react-router-dom";
import { log } from "video.js";
import Translate from "../../../../Components/Multilanguage/Translate";
import BannerUtil from "../util.jsx";

const NetflixBanner = ({ data }) => {
    const projectInfo = useSelector((state) => state?.projectInfo?.value);
    const template = projectInfo?.projectConfig?.config?.TEMPLATE;
    const [scaleDown, setScaleDown] = useState(false);
    const [initialClass, setInitialClass] = useState(false);
    const navigate = useNavigate();
    const dispatch = useDispatch()
    let fontStylesClassName = ["gagalin", "gota"]

    const { replaceImage, playClickHandler } = BannerUtil();
  
    useEffect(() => {
      setScaleDown(false);
      setTimeout(() => setInitialClass(true), 1000);
      setTimeout(() => setScaleDown(true), 3000);
    }, []);
 
  return (
    <div className="featured3">
       <Swiper
        slidesPerView={1}
        watchSlidesProgress
        effect={"fade"}
        spaceBetween={0}
        loop={true}
        autoplay={{
          delay: 4000,
          disableOnInteraction: false,
        }}
        
        className="mySwiper"
        modules={[EffectFade, Autoplay]}
        // allowSlideNext={false}
        // allowSlidePrev={false}
      >
        {data?.shows?.map((item, index) => (
          <SwiperSlide key={index}>
               <div className="playerShowCard">
                <div className="imageContainer">
                    {
                    imageUrlCheck(item?.banner || item?.logo_thumb) === true ? (
                        <img src={item?.banner || item?.logo_thumb} onError={(e) => replaceImage(e)} alt="Banner" />
                    ) : (
                        <img src={`${process.env.REACT_APP_IMAGE_URL}${item?.banner || item?.logo_thumb}`} onError={(e) => replaceImage(e)} alt="Banner" />
                    )
                    }
                    <div className={`metaData ${initialClass ? " show" : ""}`}>
                    {item?.image_title ?
                        imageUrlCheck(item?.image_title) ? (
                        <img src={item?.image_title} className={`${scaleDown ? "showTitleImage scaleDown showName" : "showName showTitleImage"}`} alt="Thumbnail" />
                        ) : (
                        <img src={`${process.env.REACT_APP_IMAGE_URL}${item?.image_title}`} alt="Thumbnail" className={`${scaleDown ? "showTitleImage scaleDown showName" : "showName showTitleImage"}`} />
                        ) : <h1 title={item?.show_name} className={`${scaleDown ? "scaleDown showName" : "showName"} ${template === "TEMPLATE_9" ? "template-9" : ""}`}>
                        {item?.show_name}
                        </h1>}
                    <div className="buttonContainer">
                        {/* { (item?.show_id || item?.event_id) &&  */}
                        <button className="play" onClick={() => playClickHandler(item)}>
                        <div className="icon">
                            <PlayIcon />
                        </div>
                        <span><Translate textKey={'play'} /></span>
                        </button> 
                        {/* } */}
                        {item?.video_vanity_url && <button className="moreInfo" onClick={()=> playClickHandler(item, { showMoreInfo: true })}>
                        <div className="icon">
                            <Info />
                        </div>
                        <span><Translate textKey={'more_info'} /></span>
                        </button> }
                    </div>
                    </div>
                    <div className="bottomGradient"></div>
                </div>
                </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="bottomVignette"></div>
    </div>
  );
};

export default NetflixBanner;